type UpdateFn = (deltaSeconds: number, elapsedSeconds: number) => void;

export class Loop {
  private rafId: number | null = null;
  private lastTime: number | null = null;
  private elapsed: number = 0;
  private paused: boolean = false;

  static readonly MAX_DELTA = 0.1;

  constructor(private readonly onUpdate: UpdateFn) {}

  start(): void {
    if (this.rafId !== null) return;
    const tick = (time: number) => {
      this.rafId = requestAnimationFrame(tick);
      if (this.paused) return;
      if (this.lastTime === null) {
        this.lastTime = time;
        return;
      }
      const delta = Math.min((time - this.lastTime) / 1000, Loop.MAX_DELTA);
      this.lastTime = time;
      this.elapsed += delta;
      this.onUpdate(delta, this.elapsed);
    };
    this.rafId = requestAnimationFrame(tick);
  }

  stop(): void {
    if (this.rafId !== null) {
      cancelAnimationFrame(this.rafId);
      this.rafId = null;
    }
    this.lastTime = null;
    this.elapsed = 0;
  }

  pause(): void {
    this.paused = true;
  }

  resume(): void {
    this.paused = false;
    this.lastTime = null;
  }
}
